<template>
  <div class="filters-header" @click="$emit('toggle-collapse')">
    <div class="header-left">
      <div class="icon-wrapper">
        <v-icon color="primary" size="22">mdi-filter-variant</v-icon>
      </div>
      <div>
        <h3 class="filters-title">Filtros Globais</h3>
        <p class="filters-subtitle">{{ filterSummary }}</p>
      </div>
    </div>
    <div class="header-actions" @click.stop>
      <v-btn text small @click="$emit('toggle-collapse')" class="collapse-btn" :disabled="loading">
        <v-icon small :class="{ 'rotate-icon': !isCollapsed }">mdi-chevron-down</v-icon>
        {{ isCollapsed ? 'Expandir' : 'Recolher' }}
      </v-btn>
      <v-btn small elevation="0" @click="$emit('clear-filters')" :disabled="!hasActiveFilters || loading" class="clear-btn">
        <v-icon left x-small>mdi-close</v-icon>
        Limpar Tudo
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltersHeader',
  props: {
    isCollapsed: Boolean,
    hasActiveFilters: Boolean,
    loading: Boolean,
    filterSummary: String
  }
};
</script>

<style scoped>
.filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  background: #ffffff;
  border-bottom: 2px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.filters-header:hover {
  background-color: #f9fafb;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  user-select: none;
}

.icon-wrapper {
  background: rgba(2, 52, 73, 0.08);
  border-radius: 12px;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filters-title {
  margin: 0;
  color: #023449;
  font-size: 1.25rem;
  font-weight: 700;
}

.filters-subtitle {
  margin: 4px 0 0 0;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
}

.header-actions {
  display: flex;
  gap: 12px;
  z-index: 1;
}

.collapse-btn {
  background: transparent !important;
  color: #023449 !important;
  text-transform: none;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #023449 !important;
  padding: 0 16px !important;
  transition: all 0.15s ease;
}

.collapse-btn:hover {
  background: #023449 !important;
  color: #ffffff !important;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.clear-btn {
  background: transparent !important;
  color: #dc2626 !important;
  text-transform: none;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #dc2626 !important;
  padding: 0 16px !important;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: #dc2626 !important;
  color: #ffffff !important;
}

@media (max-width: 768px) {
  .filters-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
    padding: 20px;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
  }

  .collapse-btn, .clear-btn {
    width: 100%;
  }
}
</style>